/**
 * Design-token mirror for JS/TS consumers.
 *
 * Some third-party libraries (e.g. react-hot-toast `iconTheme`) require literal
 * color strings at runtime and cannot read Tailwind utility classes. To keep
 * the design system as the single source of truth, this file exports a thin
 * JS mirror of the values defined in `tailwind.config.js`.
 *
 * IMPORTANT: This file is the ONLY allowed place outside `tailwind.config.js`
 * to declare literal color values. If you need a new color here, add it to
 * `tailwind.config.js` first and then mirror it below.
 */
export const tokens = {
  // Status colors (mirrored from theme.extend.colors.{success,danger})
  successEmerald: '#10b981', // success.emerald
  dangerRed: '#ef4444', // danger.red

  // Foreground on dark / status surfaces
  bodyInverse: '#ffffff', // body-inverse

  // Browser UI colour (<meta name="theme-color">) per theme = shell.panel
  themeColor: { dark: '#111A2E', light: '#FFFFFF' }, // --shell-panel in globals.css
} as const;
